<!--
  详情页数据删除/下架缺省图
-->
<template>
  <div class="empty_data_container">
    <div>
      <img class="img_delete" :src="imgDelete" alt="" v-if="type==3">
      <img class="img_off" :src="imgOff" alt="" v-if="type==2">
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "EmptyData",
  props: {
    type: { // 2 下架 ； 3 删除
      type: [String, Number],
      default: 3
    }
  },
  data() {
    return {
      imgDelete: require('@/assets/empty-data/delete.png'),
      imgOff: require('@/assets/empty-data/off.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.empty_data_container {
  width: 1200px;
  background-color: #fff;
  text-align: center;
  padding: 100px 0;
  font-size: 16px;
  color: #666666;
  line-height: 1;

  .img_delete {
    width: 180px;
    height: 180px;
    margin-bottom: 30px;
  }

  .img_off {
    width: 240px;
    height: 200px;
    margin-bottom: 20px;
    margin-top: -5px;
  }

  a {
    color: #0286DF;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
